import { isAdviceProduct } from "Store/advice/utils";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { useProducts } from "Store/product/productHooks";
import { isDefined } from "Utils/functions";
import { insuranceNameFromUrl } from "Utils/navigation/urlUtils";
import { useABTestingFeature } from "Utils/unleash/flagHooks";
import { FeatureFlagABTest } from "Utils/unleash/flags";

export const useUpsellFeature = (): boolean => {
  const isUpsellActive = useABTestingFeature(FeatureFlagABTest.SSX_2858_UPSELL);
  const productsFromCart = useProducts(true);
  const productFromUrl = insuranceNameFromUrl(window.location.href);

  const basisProducts = [
    INSURANCE_NAME_VALUE.CAR,
    INSURANCE_NAME_VALUE.CABIN,
    INSURANCE_NAME_VALUE.HOUSE,
    INSURANCE_NAME_VALUE.HOUSE_CONTENTS,
  ];

  const isStorebrandBranding = checkIsStorebrandBranding();
  const isBlockedProducts = !productsFromCart.some(
    (product) =>
      isAdviceProduct(product.name) ||
      product.name === INSURANCE_NAME_VALUE.HEALTH ||
      product.name === INSURANCE_NAME_VALUE.SOP_SICKNESS_LEAVE ||
      product.name === INSURANCE_NAME_VALUE.PREGNANT_AND_NEWBORN,
  );

  const isBasisProductFlow =
    isDefined(productFromUrl) && basisProducts.includes(productFromUrl);
  const isBasisProductInCart = productsFromCart.some((product) =>
    basisProducts.includes(product.name),
  );

  return (
    isUpsellActive &&
    isStorebrandBranding &&
    isBlockedProducts &&
    (isBasisProductFlow || isBasisProductInCart)
  );
};

const checkIsStorebrandBranding = (): boolean => {
  const grp = new URLSearchParams(window.location.search).get("grp");
  return !isDefined(grp);
};
